// removed by extract-text-webpack-plugin
module.exports = {"uploadContainer":"_5Pz3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/upload/index.less
// module id = 117
// module chunks = 0